

import React from 'react';

interface SEOProps {
  title: string;
  description: string;
}

export const SEO: React.FC<SEOProps> = ({ title, description }) => {
  React.useEffect(() => {
    // FIX: Cannot find name 'document'. Access via window and cast to any.
    (window as any).document.title = title;
    // FIX: Cannot find name 'document'. Access via window and cast to any.
    const metaDesc = (window as any).document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    } else {
      // FIX: Cannot find name 'document'. Access via window and cast to any.
      const meta = (window as any).document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      // FIX: Cannot find name 'document'. Access via window and cast to any.
      (window as any).document.head.appendChild(meta);
    }
  }, [title, description]);

  return null;
};